import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'

export default new Controller({
  name: 'RootRedirect',
  route: '',
  controller (Router, evt) {
    replaceUrl('/news')
  }
})
